import PropTypes from 'prop-types';
import React from 'react';

import InformationItems from './InformationItems';

import styles from './InformationList.styles';

const { StyledListContainer, StyledListTitle, StyledListSubtitle } = styles;

const InformationList = ({
  title, gapBelow, userImportance, ...restProps
}) => (
  <StyledListContainer gapBelow={gapBelow} userImportance={userImportance}>
    {title && (
      <StyledListTitle withSubtitle={Boolean(restProps.subTitle)}>
        {title}
      </StyledListTitle>
    )}
    {restProps.subTitle && (
      <StyledListSubtitle
        dangerouslySetInnerHTML={{ __html: restProps.subTitle }}
      />
    )}
    <InformationItems {...restProps} title={title} />
  </StyledListContainer>
);

InformationList.defaultProps = {
  userImportance: 'low',
  gapBelow: false,
};

InformationList.propTypes = {
  title: PropTypes.string.isRequired,
  userImportance: PropTypes.oneOf(['middle', 'high', 'low']),
  gapBelow: PropTypes.bool,
};

export default InformationList;
